import React from 'react';
import './Privacy.scss'

function Privacy() {

  return (
    <section className="about">
      <div className="box">
        <h1>
          Terms and Condition<hr />
        </h1>
      </div>

      <div>
<h3> Terms and Conditions - Aplikasi "Belajar Bahasa Korea Pemula"</h3>
<br />
Harap membaca syarat dan ketentuan ini dengan seksama sebelum menggunakan aplikasi "Belajar Bahasa Korea Pemula" ("Aplikasi") yang tersedia di platform Play Store. Dengan mengunduh, mengakses, atau menggunakan Aplikasi ini, Anda menyetujui dan mengikatkan diri pada syarat dan ketentuan berikut: <br /><br /> 

<h4>Penggunaan Aplikasi</h4>
a. Aplikasi "Belajar Bahasa Korea Pemula" adalah aplikasi mobile untuk beelajar berbahasa korea.<br /> 
b. Anda diizinkan untuk mengunduh dan menggunakan Aplikasi ini pada perangkat yang kompatibel, sesuai dengan persyaratan sistem yang ditentukan oleh Play Store.<br /> 
c. Anda bertanggung jawab sepenuhnya atas penggunaan Aplikasi ini dan setuju untuk mematuhi semua hukum yang berlaku.<br /><br />

<h4>Konten Aplikasi</h4>
a. Aplikasi ini menyajikan pelajaran grammar,vocabulary dan cara menulis dalam bahasa korea yang dibuat oleh pengguna dan/atau oleh pihak ketiga.<br />   
b. Kami berhak, tanpa pemberitahuan sebelumnya, mengubah, menghapus, atau menambah konten apa pun dalam Aplikasi ini.<br /><br />

<h4>Kepemilikan Intelektual</h4>
a. Aplikasi "Belajar Bahasa Korea Pemula" dan semua hak kekayaan intelektual terkait tetap menjadi milik kami atau pihak ketiga yang memberikan lisensi kepada kami.<br /> 
b. Kami berhak, tanpa pemberitahuan sebelumnya, mengubah, menghapus, atau menambah konten apa pun dalam Aplikasi ini.<br /><br />


<h4>Privasi Pengguna</h4>
a. Kami menghormati privasi pengguna. Informasi yang dikumpulkan atau diakses oleh Aplikasi ini akan ditangani sesuai dengan Kebijakan Privasi kami.<br /> 
b. Kami tidak bertanggung jawab atas kerugian atau kebocoran informasi yang disebabkan oleh faktor di luar kendali kami, seperti pelanggaran keamanan oleh pihak ketiga atau penggunaan yang salah oleh pengguna.<br /><br />

<h4>Batasan Tanggung Jawab</h4>
a. Kami tidak bertanggung jawab atas kerugian, kerusakan, atau klaim yang timbul langsung atau tidak langsung akibat penggunaan Aplikasi ini.<br /> 
b. Kami tidak memberikan jaminan apa pun terkait ketersediaan, keakuratan, keandalan, atau kinerja Aplikasi ini.<br /><br />

<h4>Perubahan Syarat dan Ketentuan</h4>
a. Kami berhak mengubah atau memperbarui syarat dan ketentuan ini sesuai kebijakan kami, tanpa pemberitahuan sebelumnya.<br /> 
b. Andadiwajibkan untuk memeriksa syarat dan ketentuan ini secara berkala. Penggunaan Aplikasi setelah perubahan syarat dan ketentuan berarti Anda menerima dan menyetujui perubahan tersebut.<br /><br />

<h4>Penghentian Penggunaan</h4>
a. Kami berhak untuk menghentikan atau menangguhkan penggunaan Anda atas Aplikasi ini jika Anda melanggar syarat dan ketentuan ini.<br /> 
b. Kami juga berhak untuk menghentikan atau menangguhkan pengoperasian Aplikasi ini setiap saat tanpa pemberitahuan sebelumnya.<br /><br />

<h4>Hukum yang Berlaku</h4>
a. Syarat dan ketentuan ini diatur dan ditafsirkan sesuai dengan hukum yang berlaku di negara kami.<br /> 
b. Anda setuju bahwa setiap sengketa yang timbul dari atau terkait dengan penggunaan Aplikasi ini akan diselesaikan secara eksklusif oleh pengadilan yang berwenang di wilayah hukum kami.<br /><br />

Dengan menggunakan aplikasi "Belajar Bahasa Korea Singkat," Anda mengakui dan menyetujui bahwa Anda telah membaca, memahami, dan setuju untuk terikat oleh syarat dan ketentuan ini. Jika Anda tidak setuju dengan syarat dan ketentuan ini, harap jangan menggunakan Aplikasi ini.<br /><br />

      </div>  
    </section> 
  );
}

export default Privacy;